import Empty from 'constants/empty';

const activityPointsSelector = store => store.profile.activityPoints || Empty.Object;

export { activityPointsSelector };
